<script setup lang="ts">
const currentArticle = inject(keys.currentArticle);
</script>

<template>
  <section
    v-if="currentArticle"
    class="w-full bg-[--background] py-16 text-[--foreground] sm:py-24"
    :class="currentArticle.colorTheme"
  >
    <Content width="article" class="relative flex flex-col gap-8">
      <UiArticlesTheme prefix="Tema: " />
      <h1 class="font-headline text-4xl sm:text-7xl">
        {{ currentArticle.title }}
      </h1>
      <div class="pb-8 text-xl font-semibold sm:text-3xl" v-html="currentArticle.intro" />
      <UiArticlesByline class="headline flex gap-4 text-xl sm:absolute sm:-bottom-8 sm:left-[-7.3rem] sm:items-center sm:gap-8">
        <IconsGraphicsStarTag
          class="hidden sm:flex"
          :fill="currentArticle.colorTheme"
          aria-hidden="true"
        />
      </UiArticlesByline>
    </Content>
  </section>
</template>
